// extracted by mini-css-extract-plugin
module.exports = {"card":"az_pUb","headerText":"az_qUb","divider":"az_rUb"};